export enum LocalStorageConstants {
  token = "token",
  user = "user",
  language = "language"
}